import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const RoadshowRegistrations = lazy(() => import("@/pages/admin/events/RoadshowRegistrations/RoadshowRegistrations"));
const FittripActivities = lazy(() => import("@/pages/admin/events/fit-trip-activities/FitTripActivities"));

const Error404 = lazy(() => import("@/pages/Error404"));

const eventsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "roadshows-registrations",
    children: [
      {
        index: true,
        element: <RoadshowRegistrations />,
      },
    ],
  },
  // {
  //   path: "fit-trip-activities",
  //   children: [
  //     {
  //       index: true,
  //       element: <FittripActivities />,
  //     },
  //   ],
  // },
];

export default eventsRoutes;
